import { Button, TextField } from '@react-spectrum/s2';
import { memo, useCallback, useEffect, useState } from 'react';

import { useUserSettings } from '@/hooks/useUserSettings';
import { Section } from '@/layouts/settings/Section';
import { trackEvent } from '@/utils/fullstory';

export const EmailSettings = memo(function EmailSettings() {
	const { settings, patchSettings } = useUserSettings();
	const [replyTo, setReplyTo] = useState('');

	useEffect(() => {
		setReplyTo(settings?.reply_to_email ?? '');
	}, [settings?.reply_to_email]);

	const handleSave = useCallback(() => {
		const trimmed = replyTo.trim();
		trackEvent('Email Settings Reply-To Saved', {
			has_value: trimmed.length > 0,
		});
		void patchSettings({ reply_to_email: trimmed });
	}, [patchSettings, replyTo]);

	return (
		<Section title="Email Settings">
			<div className="flex flex-col gap-1.5">
				<span className="text-sm font-bold text-[var(--text-muted)]">
					Reply-to email address
				</span>
				<div className="flex items-center gap-3">
					<div className="flex-1">
						<TextField
							aria-label="Reply-to email address"
							placeholder="Enter your email address"
							value={replyTo}
							onChange={setReplyTo}
							type="email"
							UNSAFE_className="w-full"
						/>
					</div>
					<Button variant="primary" onPress={handleSave}>
						Save
					</Button>
				</div>
				<p className="text-sm text-[var(--text-muted)] italic">
					Recipients will reply to this address when they respond to your emails
				</p>
			</div>
		</Section>
	);
});
